import React from "react";
import Props from "../../models/Properties"
import Form from 'react-bootstrap/Form';

const InputBool: React.FC<{data: any}> = (props) => {
    const [value, setValue] = React.useState(Props.currentValue(props.data.prop));

    function changeHandler(e: React.ChangeEvent<HTMLInputElement>) {
        setValue(e.target.checked);
        props.data.onChange(props.data.prop, e.target.checked);
        //setValue((prevState: boolean)=>{return !prevState})
    }

    return (
        <Form.Check 
            type="checkbox" 
            label={props.data.prop.title} 
            checked={value} onChange={changeHandler} readOnly={props.data.prop.readOnly}
        />
    );
};

export default InputBool;
